import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import BootstrapTable from 'react-bootstrap-table-next';
import Select  from 'react-select';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import AllapotItem from './AllapotItem';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import { all, reject, resolve } from 'superagent/lib/request-base';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../UgyfelszolgalatTooltips';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const kezdoAllapotAzonosito = 'KEZDO';
const vegsoAllapotAzonosito = 'VEGSO';


const getListStyle = isDraggingOver => ({
  // background: isDraggingOver ? "lightblue" : "lightgrey",
  paddingTop: 0,
  paddingRight: 8,
  paddingBottom: 0,
  paddingLeft: 8,
  width: '100%'
});

class EsettipusLista extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      formAllapotStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      currentId: undefined,
      torlesId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalDelete: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      // FORM VALUES
      formNev: '',
      formAzonosito: '',
      formLeiras: '',
      formHatarido: '',
      formEmlekezteto: '',
      formPublikus: false,
      formErtesitendoValue: [],
      formAkadalymentesitett: false,
      formHasznalhato: true,
      formErtesitendo: [],
      formFelelos: '',
      formEszkalaciosValue: '',
      // fixedAllapotItems: [],
      selectableAllapotItems: [],
      items: [],
      ertesitesOptions: [],
      emailKuldesOptions: [],
      allapotItems: [],
    };
  }

  componentDidMount() {
    // this.listEsettipus();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.listEsettipus();
      }
    }
  }

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      // this.state.items && this.state.items.filter(x => x.torolheto),
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({
      items
    });
  }

  toggleNested = () => {
    this.setState(prevState => ({ nestedModal: !prevState.nestedModal }));
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  }

  listEsettipus = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listEsettipus((err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  formatErtesitendoData = (ertesitendok) => {
    return ertesitendok && ertesitendok.map((ertesitendo) => {
      return {
        id: ertesitendo.szemelyid,
        nev: ertesitendo.nev,
        email: ertesitendo.email
      };
    });
  }

  // getEsettipus = (id) => {
  //   this.setState({
  //     formStatus: 'LOAD'
  //   });
  //   Services.getEsettipus(id, (err, res) => {
  //     if (!err) {
  //       this.setState({
  //         formStatus: 'DATA',

  //         formNev: this.nullToString(res[0].nev),
  //         formAzonosito: this.nullToString(res[0].azonosito),
  //         formLeiras: this.nullToString(res[0].leiras),
  //         formPublikus: res[0].publikus,
  //         formHatarido: this.nullToString(res[0].hatarido),
  //         formErtesitendoValue: this.formatErtesitendoData(res[0].ertesitendo),
  //         formFelelosValue: res[0].felelos,
  //         items: res[0].allapot,
  //         // fixedAllapotItems: result
  //       });
  //     } else {
  //       this.setState({
  //         formStatus: 'NETW'
  //       });
  //     }
  //   });
  // }

  // getEsettipusPromise = (id) => {
  //   return new Promise((resolve, reject) => {
  //     Services.getEsettipus(id, (err, res) => {
  //       if (!err) {
  //         this.setState({
  //           formNev: this.nullToString(res[0].nev),
  //           formAzonosito: this.nullToString(res[0].azonosito),
  //           formLeiras: this.nullToString(res[0].leiras),
  //           formPublikus: res[0].publikus,
  //           formHatarido: this.nullToString(res[0].hatarido),
  //           formErtesitendoValue: this.formatErtesitendoData(res[0].ertesitendo),
  //           formFelelosValue: res[0].felelos,
  //           items: res[0].allapot,
  //           // fixedAllapotItems: result
  //         }, () => {
  //           resolve();
  //         });
  //       } else {
  //         reject(new Error('Hálozati hiba!'));
  //       }
  //     });
  //   });
  // }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleColorChange = (color) => {
    this.setState({ formSzinkod: color.hex.substr(1, 6) });
  }

  handleEditClick = (cell) => {
    this.setState({
      formType: 'MOD',
      currentId: cell,
      formStatus: 'LOAD',
      modalForm: true
    }, () => {
      // this.getEsettipus(cell);
      Promise.all([
        // this.getEsettipusPromise(cell),
        this.initEsettipusPromise(cell)
      ])
        .then(() => {
          this.setState({ formStatus: 'DATA' });
        })
        .catch(() => {
          this.setState({
            formStatus: 'NETW'
          });
        });
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell,
    }, () => {
      this.toggleDeleteModal();
    });
  }

  deleteEsettipus = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteEsettipus(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listEsettipus();
        this.props.globals.addSuccess('Esettípus törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'LOAD',
      formNev: '',
      formAzonosito: '',
      formHatarido: '',
      formEmlekezteto: '',
      formLeiras: '',
      // fixedAllapotItems: [],
      formErtesitendoValue: [],
      formFelelosValue: null,
      formEszkalaciosValue: null,
      items: [],
      modalForm: true,
      formPublikus: false,
      currentId: undefined
    }, () => {
      Promise.all([
        this.initEsettipusPromise()
      ])
        .then(() => {
          this.setState({ formStatus: 'DATA' });
        })
        .catch(() => {
          this.setState({
            formStatus: 'NETW'
          });
        });
    });
  }

  initEsettipusPromise = (id) => {
    return new Promise((resolve, reject) => {
      Services.initForm(id, (err, res) => {
        if (!err){

          let items = [];
          if (!id) {
            res[0].allapot.forEach(x => {
              x.email = x.azonosito === kezdoAllapotAzonosito ? 'BELSO_KULSO_KULDES' : 'NINCS';
              items.push(x);
            });
          } else if (res[0].esettipus && res[0].esettipus.allapot) {
            res[0].esettipus.allapot.forEach(x =>{
              let o = res[0].allapot.find(y => y.id === x[0]);
              if (o) {
                o.email = x[1];
                items.push(o);
              }
            });
          }


          this.setState({
            formAzonosito: res[0].esettipus && this.nullToString(res[0].esettipus.azonosito),
            formNev: res[0].esettipus && this.nullToString(res[0].esettipus.nev),
            formLeiras: res[0].esettipus && this.nullToString(res[0].esettipus.leiras),
            formHatarido: res[0].esettipus && this.nullToString(res[0].esettipus.hatarido),
            formEmlekezteto: res[0].esettipus && this.nullToString(res[0].esettipus.emlekezteto),
            formPublikus: res[0].esettipus && res[0].esettipus.publikus ? true : false,
            formErtesitendo: res[0].dolgozo,
            formErtesitendoValue: res[0].esettipus && this.formatErtesitendoData(res[0].esettipus.ertesitendo),
            formFelelosValue: res[0].esettipus && res[0].esettipus.felelos,
            formEszkalaciosValue: res[0].esettipus && res[0].esettipus.eszkalacios,
            emailKuldesOptions: res[0].email,
            items: items,
          }, () => {
            resolve();
          });
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  contains = (element, array) => {
    let result = false;
    array.forEach((allapot) => {
      if (element.id === allapot.id) {
        result = true;
      }
    });
    return result;
  }

  listAllapotModal = () => {
    this.setState({
      formAllapotStatus: 'LOAD'
    });
    Services.listAllapot((err, res) => {
      if (!err) {
        // res[0].pop();
        // res[0].shift();
        let selectable = [];
        res[0].forEach((element) => {
          if (!(this.contains(element, this.state.items))) {
            selectable.push(element);
          }
        });
        this.setState({
          formAllapotStatus: 'DATA',
          selectableAllapotItems: selectable
        });
      } else {
        this.setState({
          formAllapotStatus: 'NETW'
        });
      }
    });
  }

  getAllapotArray = () => {
    let result = [];
    
    this.state.items.forEach((allapot) => {
      result.push({ first: allapot.id.toString(), second: allapot.email });
    });

    return result;
  }

  submitForm = (e, values) => {
    const {
      currentId,
      formType
    } = this.state;

    const {
      formNev,
      formAzonosito,
      formHatarido,
      formEmlekezteto,
      formLeiras,
      formPublikus,
    } = values;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {};

      submitObj.azonosito = this.emptyOrNull(formAzonosito);
      submitObj.nev = this.emptyOrNull(formNev);
      submitObj.hatarido = this.emptyOrNull(formHatarido);
      submitObj.emlekezteto = this.emptyOrNull(formEmlekezteto);
      submitObj.leiras = this.emptyOrNull(formLeiras);
      submitObj.publikus = formPublikus ? true : false;
      submitObj.allapot = this.getAllapotArray();
      submitObj.ertesitendo = this.state.formErtesitendoValue && this.state.formErtesitendoValue.map(item => item.id);
      submitObj.felelosid = this.state.formFelelosValue && this.state.formFelelosValue.id;
      submitObj.eszkalaciosid = this.state.formEszkalaciosValue && this.state.formEszkalaciosValue.id;

      Services.addEsettipus(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Esettípus felvéve!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listEsettipus();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    } else if (formType === 'MOD') {
      let submitObj = {};

      submitObj.id = this.emptyOrNull(currentId);
      submitObj.nev = this.emptyOrNull(formNev);
      submitObj.hatarido = this.emptyOrNull(formHatarido);
      submitObj.emlekezteto = this.emptyOrNull(formEmlekezteto);
      submitObj.leiras = this.emptyOrNull(formLeiras);
      submitObj.publikus = formPublikus ? true : false;
      submitObj.allapot = this.getAllapotArray();
      submitObj.ertesitendo = this.state.formErtesitendoValue && this.state.formErtesitendoValue.map(item => item.id);
      submitObj.felelosid = this.state.formFelelosValue && this.state.formFelelosValue.id;
      submitObj.eszkalaciosid = this.state.formEszkalaciosValue && this.state.formEszkalaciosValue.id;

      Services.editEssettipus(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Esettípus módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listEsettipus();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          {this.props.globals.hasRole(['UGYFELSZOLGALAT_ESETTIPUS'], true) && (
            <React.Fragment>
              <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                {'Módosítás'}
              </UncontrolledTooltip>
              <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
                {'Törlés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

  tableBooleanFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-danger">Nem</span>;
  }

  allapotFormatter = (cell) => {
    return cell.map((allapot) => {
      return (
        <React.Fragment>
          <span className="badge" style={{ backgroundColor: '#' + allapot.szin, color: this.getCorrectTextColor('#' + allapot.szin) }}>{allapot.nev}</span>
          <br />
        </React.Fragment>
      );
    });
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új esettípus létrehozása';
      case 'MOD':
        return 'Esettípus módosítása';
      default:
        return '';
    }
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'nev',
        text: 'Esettípus megnevezés',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'leiras',
        text: 'Leírás',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: false
      },
      {
        dataField: 'hatarido',
        text: 'Határidő (óra)',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        align: 'center',
        sort: false,
        headerStyle: { width: '125px' }
      },
      {
        dataField: 'ertesitendo',
        text: 'Értesítendő (e-mail)',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        // formatter: this.ertesitendoFormatter,
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: false
      },
      {
        dataField: 'felelos',
        text: 'Felelős',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: false
      },
      {
        dataField: 'publikus',
        text: 'Publikus',
        formatter: this.tableBooleanFormatter,
        align: 'center',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: false,
        headerStyle: { width: '125px' }
      },
      {
        dataField: 'allapot',
        text: 'Állapotok',
        formatter: this.allapotFormatter,
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: false,
        headerStyle: { width: '200px' }
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !this.props.globals.hasRole(['UGYFELSZOLGALAT_ESETTIPUS'], true),
        formatter: this.tableIconFormatter,
        headerStyle: { width: '125px' }
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  formatCreateLabel = input => (
    <span>
      <i>
        {'Hozzáadás: '}
      </i>
      {input}
    </span>
  );

  onNewAllapotModalClick = () => {
    this.setState({
      nestedModal: true
    }, () => {
      this.listAllapotModal();
    });
  }

renderForm = () => {
  const {
    formNev,
    formAzonosito,
    formHatarido,
    formEmlekezteto,
    formLeiras,
    formPublikus,
    formType
  } = this.state;

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-7">
          <div className="row">
            <div className="col-md-12">
              <p style={{
                marginBottom: 15,
                marginTop: 15,
                fontSize: '1.25rem',
                fontWeight: 500,
                lineHeight: 1.1
              }}
              >
              Eset alapadatai:
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <RFField
                label="Azonosító: *"
                name="formAzonosito"
                maxLength="10"
                disabled={formType === 'MOD'}
                value={formAzonosito}
                onChange={this.handleInputChange}
                required
              />
            </div>
            <div className="col-md-6">
              <RFField
                label="Megnevezés: *"
                name="formNev"
                value={formNev}
                onChange={this.handleInputChange}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <RFField
                label="Leírás: "
                name="formLeiras"
                value={formLeiras}
                onChange={this.handleInputChange}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <RFField
                label="Határidő:"
                name="formHatarido"
                type="number"
                value={formHatarido}
                onChange={this.handleInputChange}
                append="óra"
              />
            </div>
            {formHatarido &&
              <div className="col-md-4">
                <RFField
                  append="óra"
                  label={(<div>
                    Emlékeztető:
                      <i
              className="fa fa-info-circle pull-right"
              id="dnd-info-tooltip-emlekezteto"
              aria-hidden="true"
              style={{ fontSize: '0.875rem', fontWeight: 'normal', lineHeight: 1.5 }}
            />
          <UncontrolledTooltip trigger='hover focus-visible' placement="right" target="dnd-info-tooltip-emlekezteto">
            <span>
              Az Értesítendő (aktív) személyeknek az itt megadott óra értékkel a határidő lejárata előtt kerül emlékeztető küldésre a határidő lejáratáról.
            </span>
          </UncontrolledTooltip>
                    </div>)}
                  name="formEmlekezteto"
                  type="number"
                  value={formEmlekezteto}
                  onChange={this.handleInputChange}
                />
              </div>
            }
            <div className="col-md-4 margin-top-35">
              <RFField
                label="Publikus eset"
                type="checkbox"
                name="formPublikus"
                value={formPublikus}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Label for="formErtesitendok">Értesítendő (e-mail): {<CustomTooltip text={getTooltip('ertesitendo')} id="ertesitendoTT" />}</Label>
              <Select
                styles={{
                  control: base => ({
                    ...base,
                    '&:focus': { borderColor: 'red' }, // border style on hover
                    border: '1px solid lightgray', // default border color
                    boxShadow: 'none', // no box-shadow
                    borderRadius: '0',
                    marginBottom: 16
                  }),
                }}
                name="formErtesitendok"
                id="formErtesitendok"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                formatCreateLabel={this.formatCreateLabel}
                onChange={v => this.setState({ formErtesitendoValue: v })}
                options={this.state.formErtesitendo}
                isMulti
                getOptionLabel={option => option.nev + (option.email ? ' - ' + option.email : '')}
                getOptionValue={option => option.id}
                isOptionDisabled={option => option.allapot === 'INAKTIV'}
                value={this.state.formErtesitendoValue}
                cache={false}
                autoload={false}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Label for="formFelelos">Felelős személy:</Label>
              <Select
                styles={{
                  control: base => ({
                    ...base,
                    '&:focus': { borderColor: 'red' }, // border style on hover
                    border: '1px solid lightgray', // default border color
                    boxShadow: 'none', // no box-shadow
                    borderRadius: '0',
                    marginBottom: 16
                  }),
                }}
                name="formFelelos"
                id="formFelelos"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                formatCreateLabel={this.formatCreateLabel}
                onChange={v => this.setState({ formFelelosValue: v })}
                options={this.state.formErtesitendo}
                getOptionLabel={option => option.nev + (option.email ? ' - ' + option.email : '')}
                getOptionValue={option => option.id}
                isOptionDisabled={option => option.allapot === 'INAKTIV'}
                value={this.state.formFelelosValue}
                cache={false}
                autoload={false}
                isClearable
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Label for="formEszkalacios">Eszkalációs személy:</Label>
              <Select
                styles={{
                  control: base => ({
                    ...base,
                    '&:focus': { borderColor: 'red' }, // border style on hover
                    border: '1px solid lightgray', // default border color
                    boxShadow: 'none', // no box-shadow
                    borderRadius: '0',
                    marginBottom: 16
                  }),
                }}
                name="formEszkalacios"
                id="formEszkalacios"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                formatCreateLabel={this.formatCreateLabel}
                onChange={v => this.setState({ formEszkalaciosValue: v })}
                options={this.state.formErtesitendo}
                getOptionLabel={option => option.nev + (option.email ? ' - ' + option.email : '')}
                getOptionValue={option => option.id}
                isOptionDisabled={option => option.allapot === 'INAKTIV'}
                value={this.state.formEszkalaciosValue}
                cache={false}
                autoload={false}
                isClearable
              />
            </div>
          </div>
        </div>
        <div className="col-md-5" style={{ backgroundColor: '#ececec', borderLeft: '1px solid #cfd8dc' }}>
          <p style={{
            marginBottom: 15,
            marginTop: 15,
            fontSize: '1.25rem',
            fontWeight: 500,
            lineHeight: 1.1
          }}
          >
            Elérhető állapotok / Email értesítés:
            <i
              className="fa fa-info-circle pull-right"
              id="dnd-info-tooltip"
              aria-hidden="true"
              style={{ fontSize: '0.875rem', fontWeight: 'normal', lineHeight: 1.5 }}
            />
          </p>
          <UncontrolledTooltip trigger='hover focus-visible' placement="right" target="dnd-info-tooltip">
            <span>
              A sorrend megváltoztatásához mozgasd az állapot kártyákat.
            </span>
            <br />
            <br />
            <span>
              Az itt megadott érték szerint kerül küldésre az Értesítendő (aktív) személyeknek egy e-mail értesítés az adott állapotba kerülésről.
            </span>
          </UncontrolledTooltip>
          <DragDropContext onDragEnd={this.onDragEnd}>
            {this.renderItem(this.state.items.filter(x => x.azonosito == kezdoAllapotAzonosito), 0, true, 'Kezdo')}
            {this.renderItem(this.state.items.filter(x => x.torolheto), 1, false, 'Allapot')}
            {this.renderItem(this.state.items.filter(x => x.azonosito == vegsoAllapotAzonosito), this.state.items.length - 1, true, 'Vegso')}
          </DragDropContext>
          <button
            type="button"
            className="btn btn-success btn-circle pull-right"
            style={{
              marginBottom: 10,
              marginRight: 6
            }}
            onClick={() => {
              this.onNewAllapotModalClick();
            }}
          >
            <i className="fa fa-plus" />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

renderItem = (items, startIndex, disableDrop, droppableId) => {
  // <Droppable droppableId="droppable">
  //             {(provided, snapshot) => (
  //               <div
  //                 {...provided.droppableProps}
  //                 ref={provided.innerRef}
  //                 style={getListStyle(snapshot.isDraggingOver)}
  //               >
  //                 {/* {this.state.items && this.state.items.filter(x => x.torolheto).map((item, index) => ( */}
  //                 {
  //                 this.state.items /*&& this.state.items.filter(x => x.torolheto)*/.map((item, index) => (
  //                   <Draggable key={'K'+item.id.toString()} draggableId={item.id.toString()} index={index} isDragDisabled={item.azonosito === 'KEZDO' || item.azonosito === 'VEGSO'}>
  //                     {(providedd, snapshott) => (
  //                       <AllapotItem
  //                         id={item.id.toString()}
  //                         text={item.nev}
  //                         bgColor={item.szin}
  //                         textColor={this.getCorrectTextColor('#' + item.szin)}
  //                         provided={providedd}
  //                         snapshot={snapshott}
  //                         deleteItem={this.handleDeleteItemClick}
  //                         emailKuldes={item.email}
  //                         emailKuldesChange={this.handleEnumChange}
  //                         options={this.state.emailKuldesOptions}
  //                       />
  //                     )}
  //                   </Draggable>
  //                 ))}
  //                 {provided.placeholder}
  //               </div>
  //             )}
  //           </Droppable>
  
  return (
    <Droppable droppableId={"droppable" + droppableId} isDropDisabled={disableDrop}>
    {(provided, snapshot) => (
      <div
        {...provided.droppableProps}
        ref={provided.innerRef}
        style={getListStyle(snapshot.isDraggingOver)}
      >
        {/* {this.state.items && this.state.items.filter(x => x.torolheto).map((item, index) => ( */}
        {
        items /*&& this.state.items.filter(x => x.torolheto)*/.map((item, index) => (
          <Draggable key={item.id.toString()} draggableId={item.id.toString()} index={parseInt(startIndex + index)} isDragDisabled={disableDrop}>
            {(providedd, snapshott) => (
              <AllapotItem
                id={item.id}
                text={item.nev}
                bgColor={item.szin}
                textColor={this.getCorrectTextColor('#' + item.szin)}
                provided={providedd}
                snapshot={snapshott}
                deleteItem={disableDrop ? null : this.handleDeleteItemClick}
                emailKuldes={item.email}
                emailKuldesChange={this.handleEnumChange}
                options={this.state.emailKuldesOptions}
              />
            )}
          </Draggable>
        ))}
        {provided.placeholder}
      </div>
    )}
  </Droppable>);
}

handleDeleteItemClick = (id) => {
  let items = JSON.parse(JSON.stringify(this.state.items));
  items.splice(items.findIndex((item) => {
    return item.id === id;
  }), 1);
  this.setState({
    items: items
  });
}

handleEnumChange = (e, id) => {
  let items = this.state.items;
  items.forEach(item => {
    if (item.id === id)
      item.email = e.target.value;
  })
  this.setState({
    items: items
  });
}

onAllapotSelect = (allapot) => {
  this.setState({
    nestedModal: false,
  }, () => {
    let items = JSON.parse(JSON.stringify(this.state.items));
    allapot.email = 'NINCS';
    items.splice(items.length - 1, 0, allapot);
    
    this.setState({
      items
    })
  });
}

renderAllapotList = () => {
  return this.state.selectableAllapotItems.map((allapot) => {
    return (
      <div
        style={{
        padding: 8,
        paddingBottom: 2,
        width: '100%',
        cursor: 'pointer'
        }}
        onClick={()=> { this.onAllapotSelect(allapot); }}
      >
        <div className="card bg-light dnd-list" style={{ marginBottom: 0 }} >
          <div className="card-body" style={{ padding: 10, backgroundColor: '#' + allapot.szin, color: this.getCorrectTextColor('#' + allapot.szin) }}>
            <span>
              {allapot.nev}
            </span>
          </div>
        </div>
      </div>
    );
  });
}

render() {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
          {this.props.globals.hasRole(['UGYFELSZOLGALAT_ESETTIPUS'], true) && (
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új esettípus'}
            </Button>
          )}
        </div>
        <div className="col-md-12">
          {{
            LOAD: (<Loader />),
            DATA: (<DataEmptyState
              hasImage
              subtitle="Vigyél fel új tételt!"
            />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => { this.listEsettipus(); }}
            />),
            TABL: (this.renderTable())
          }[this.state.tableStatus]}
        </div>
      </div>
      <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="lg">
        <RFForm
          modal
          onSubmit={this.submitForm}
          title={this.renderFormTitle()}
          footer={
            <>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Mégsem</Button>
            </>
          }
        >
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => { this.state.currentId ? this.initEsettipusPromise(this.state.currentId) : this.handleNewClick(); }}
            />),
            DATA: (this.renderForm())
          }[this.state.formStatus]}
          <Modal isOpen={this.state.nestedModal} toggle={this.toggleNested} backdrop="static">
            <ModalHeader>Állapot hozzáadása</ModalHeader>
            <ModalBody>
              {{
                LOAD: (<Loader />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => {}}
                />),
                DATA: (this.renderAllapotList())
              }[this.state.formAllapotStatus]}
            </ModalBody>
            <ModalFooter>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleNested}>Mégsem</Button>
            </ModalFooter>
          </Modal>
        </RFForm>
      </Modal>
      <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
        <ModalHeader>Törlés</ModalHeader>
        <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.deleteEsettipus()}
            loading={this.state.deleteButtonLoading}
          >
            {'Igen'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}
}

EsettipusLista.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default EsettipusLista;
